"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserMedia = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const domain_1 = require("@home-health-notify/domain");
const useEffectCancellable_1 = require("./useEffectCancellable");
const useUserMedia = () => {
    const { selectedOrgUser } = (0, react_1.useContext)(context_1.OrganizationContext);
    const { chat } = (0, react_1.useContext)(context_1.ChatContext);
    const chatId = chat === null || chat === void 0 ? void 0 : chat.getChatId();
    const groupType = chat === null || chat === void 0 ? void 0 : chat.chatInfo.groupType;
    const [userMedia, setUserMedia] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const getUserMedia = (context) => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        yield (chat === null || chat === void 0 ? void 0 : chat.fetchUserMedia(context));
        if (!context.isAborted) {
            (chat === null || chat === void 0 ? void 0 : chat.userMedia) && setUserMedia(chat === null || chat === void 0 ? void 0 : chat.userMedia);
            setIsLoading(false);
        }
    });
    (0, useEffectCancellable_1.useEffectCancellable)(context => {
        const chatManager = groupType &&
            (selectedOrgUser === null || selectedOrgUser === void 0 ? void 0 : selectedOrgUser.chatManager.getChatManagerForGroupType(groupType));
        const shouldFetchUserMedia = chatId && chatManager && groupType === domain_1.GROUP_TYPE.PRIVATE;
        if (shouldFetchUserMedia) {
            getUserMedia(context);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chatId]);
    return {
        isLoading,
        userMedia,
    };
};
exports.useUserMedia = useUserMedia;
